export const parseFullName = (fullName: string = '') => {
  const [firstName, ...rest] = fullName.trim().split(/\s+/);
  const lastName = rest.join(' ');

  return {
    firstName,
    lastName,
  };
};
